import React from "react";
import { plan2plateIcons } from "../../utils/iconUtils";
import { Plan2PlateIcon } from "../Plan2PlateIcon";
import { layout } from "../../theme/layout";
import { Spinner } from "../ui/Spinner";
import { Glyph } from "../SmallIconButton";

export function FloatingButton(props: {
  onClick: () => void;
  caption: string;
  position?: React.CSSProperties["position"];
  zIndex?: React.CSSProperties["zIndex"];
  leftIcon?: keyof typeof plan2plateIcons;
  isLoading?: boolean;
  maxW?: string;
}) {
  return (
    <div
      className="pointer-events-none flex w-full items-center justify-center"
      style={{
        left: "0px",
        right: "0px",
        marginLeft: "auto",
        marginRight: "auto",
        maxWidth: props.maxW || layout.maxW,
        bottom: "16px",
        position: props.position || "absolute",
        zIndex: props.zIndex,
        visibility: "hidden",
      }}
    >
      <button
        data-cy="floating-button"
        type="button"
        onClick={props.onClick}
        disabled={props.isLoading}
        className="pointer-events-auto flex items-center gap-2 rounded-card bg-teal px-4 py-2 font-bold text-white shadow-card hover:brightness-110 active:brightness-95 disabled:opacity-60"
        style={{
          visibility: "visible",
          paddingLeft: props.leftIcon ? "8px" : undefined,
        }}
      >
        {props.isLoading ? (
          <Spinner className="h-4 w-4" />
        ) : (
          props.leftIcon && (
            <Glyph
              icon={props.leftIcon}
              className="[&_polyline]:!stroke-white [&_polyline]:!stroke-[2px]"
            />
          )
        )}
        {props.caption}
      </button>
    </div>
  );
}
